import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";


type EditCourseDTO  = {
    id:string;
    name:string;
    img_url:string;
    description:string;
} & ApiError;

export const EditCertificate = (data: EditCourseDTO , id:string): Promise<EditCourseDTO> => {
    return axios.patch(`/certificate-exam/${id}`, data)
        .then(response => response.data as EditCourseDTO);
};